import { styled } from '@linaria/react'
import { ButtonSC } from 'atoms/Button'
import { ChangeUsernamePasswordBlockSC } from 'containers/ChangeUsernamePasswordBlock'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { MEDIA } from 'vars/media'

export const ChangeUsernamePasswordFormSC = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${ChangeUsernamePasswordBlockSC} {
    &:first-child {
      margin-bottom: var(${FIXED_INDENTS.INDENT_50});

      ${MEDIA.MIN_600} {
        margin-bottom: var(${FIXED_INDENTS.INDENT_60});
      }

      ${MEDIA.MIN_1240} {
        margin-bottom: var(${FIXED_INDENTS.INDENT_80});
      }
    }
  }

  & > ${ButtonSC} {
    width: 192px;
    margin-top: var(${FIXED_INDENTS.INDENT_50});

    ${MEDIA.MIN_600} {
      margin-top: var(${FIXED_INDENTS.INDENT_60});
    }

    ${MEDIA.MIN_1240} {
      margin-top: var(${FIXED_INDENTS.INDENT_80});
    }
  }
`
